import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const SlackWorkspaceMessagesServiceContext = createContext(undefined)

const SlackWorkspaceMessagesServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={SlackWorkspaceMessagesServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/api/v1/org/slack_workspace_messages`, payload)
          return data
        },
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/org/slack_workspace_messages${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

SlackWorkspaceMessagesServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useSlackWorkspaceMessagesService = () => {
  const context = useContext(SlackWorkspaceMessagesServiceContext)
  if (context === undefined) {
    throw new Error('SlackWorkspaceMessagesServiceContext was not provided. Make sure your component is a child of the SlackWorkspaceMessagesServiceProvider.')
  }
  return context
}

const useSlackWorkspaceMessagesQuery = ({query, ...otherProps}) => {
  const slackWorkspaceMessagesService = useSlackWorkspaceMessagesService()
  return useSimpleQuery({
    queryKey: `slack_workspace_messages-list-${JSON.stringify(query)}`,
    queryFn: async () => slackWorkspaceMessagesService.list(query),
    ...otherProps
  })
}

export {SlackWorkspaceMessagesServiceProvider, useSlackWorkspaceMessagesService, useSlackWorkspaceMessagesQuery}
